define('services/activity-watcher',['underscore', 'bootbox', 'services/i18n', 'services/platform.service'], function (_, Bootbox, i18n, PlatformService) {

    var INACTIVE_TIMEOUT_MILLISECONDS = 14400000; // 4 hours
    var ACTIVITY_EVENTS = [
        'mousedown'
    ];

    var ActivityWatcher = {
        start: function () {
            // Don't start activity watcher on native platforms
            if (PlatformService.isNative()) {
                return;
            }

            this.stopPreviousActiveWatcher();

            // If null, then no watchers currently exists
            this.timeoutID = null;

            /**
             * https://stackoverflow.com/questions/10444077/javascript-removeeventlistener-not-working#comment73217796_10444156
             */
            this.onActivityFunc = this.onActivity.bind(this);

            this.registerEvents();
            this.setupTimeout();
        },

        setupTimeout: function () {
            var self = this;
            this.timeoutID = window.setTimeout(function () {
                self.stop().askForRefresh();
            }, INACTIVE_TIMEOUT_MILLISECONDS);
        },

        stop: function () {
            window.clearTimeout(this.timeoutID);
            this.timeoutID = null;
            this.unregisterEvents();

            return this;
        },

        isRunning: function() {
            return ! _.isNull(this.timeoutID);
        },

        askForRefresh: function() {
            Bootbox.confirm({
                message: i18n.t('inactive-refresh-message'),
                context: this,
                callback: function(result) {
                    if (result) {
                        window.location.reload();
                    } else {
                        this.registerEvents();
                        this.setupTimeout();
                    }
                }
            });
        },

        unregisterEvents: function () {
            ACTIVITY_EVENTS.forEach(function (eventName) {
                document.removeEventListener(eventName, this.onActivityFunc);
            }, this);
        },

        registerEvents: function () {
            ACTIVITY_EVENTS.forEach(function (eventName) {
                document.addEventListener(eventName, this.onActivityFunc);
            }, this);
        },

        onActivity: function () {
            window.clearTimeout(this.timeoutID);
            this.setupTimeout();
        },

        stopPreviousActiveWatcher: function() {
            if (this.timeoutID) {
                this.stop();
            }
        }

    };

    return ActivityWatcher;
});

